import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { resolve } from 'dns';
import { get, reject, result } from 'lodash';
import { error } from 'console';


const contentType= 'Content-Type';
const applicationJson = "application/json";
const csrfToken = "X-CSRF-TOKEN";

@Injectable({
  providedIn: "root",
})


export class ApiService {

  // headers
  headers: any = new HttpHeaders({
    contentType: "application/x-www-form-urlencoded",
    csrfToken: window["jhConfig"] ? window["jhConfig"].token : '',
  });

  constructor(private http: HttpClient) { }


  // NPPES API
  physicianSearch(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post('/nppes/physician-search', data, {
      headers: customHeaders
    });
  }

  // Check display status of consolidated Application PDF file
  // pdf/checkPDFFileDisplay
  checkPDFFileDisplayStatus(applicationId: string): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');
    const params: any = new HttpParams().set("appId", applicationId);

    return this.http.get("/pdf/checkPDFFileDisplayStatus", {
      headers: customHeaders,
      params: params,
    });
  }

  // Upload Illustration PDF file
  uploadIllustrationFile(appAuthId: string, questionName: string, illustrationFile: File): Observable<any> {

    const customHeaders = new HttpHeaders().set(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');
    const params: any = new HttpParams().set("AppAuthId", appAuthId).set('QuestionName', questionName);;

    const formData: FormData = new FormData();
    formData.append('illustrationFile', illustrationFile, illustrationFile.name);

    return this.http.post("/pdf/uploadIllustrationFile", formData, {
      headers: customHeaders, params
    });
  }

  // Upload Illustration PDF file
  uploadIllustrationFileX(appAuthId: string, illustrationFile: File): Observable<any> {

    const customHeaders = new HttpHeaders().set(contentType, 'multipart/form-data');
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');
    const params: any = new HttpParams().set("AppAuthId", appAuthId);

    let illustrationFileData;
    const illustrationPromise = this.readAsDataURL(illustrationFile);
    illustrationPromise
    .then(response => {
      illustrationFileData = response;
    })
    .catch(uploadPdfError => {
      console.log(uploadPdfError); illustrationFileData = null;
    })

    const formData: FormData = new FormData();
    formData.append('illustrationFile', illustrationFileData);

    return this.http.post("/pdf/uploadIllustrationFile", formData, {
      headers: customHeaders, params
    });

  }

  async readAsDataURL(ifile: File) {
    let base64Data: any;
    let base64Response: any;
    try {
      base64Response = await this.readBase64Data(ifile);
      base64Data = base64Response.replace(/^data:.+;base64,/, '');
    } catch (readBase64Error) {
      console.log(readBase64Error);
      base64Data = null;
    } finally {
      return base64Data;
    }
  }

  readBase64Data(file: File) {
    return new Promise((resolveBase64, rejectBase64) => {
      const fr = new FileReader();
      fr.onerror = rejectBase64;
      fr.onload = () => {
        resolveBase64(fr.result);
      }
      fr.readAsDataURL(file);
    });
  }

  // form data: states
  getStates(): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );

    return this.http.get("/feed/get-states", {
      headers: customHeaders,
    });
  }

  // form data: countries
  getCountries(): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );

    return this.http.get("/dist/countries.json", {
      headers: customHeaders,
    });
  }

  // form data: medications
  getMedications(): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);

    return this.http.get('/feed/get-medications', {
      headers: customHeaders
    });
  }



  // form data: questions
  getRawData() {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken,  window["jhConfig"] ? window["jhConfig"].token : '');
    return this.http.post("/service/composable/AppDefinition", {
      headers: customHeaders
    });
  }

  // // form data: conditional dependency data model
  getDependencies() {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken,  window["jhConfig"] ? window["jhConfig"].token : '');
    return this.http.post("/service/composable/ConditionalDependencies", {
      headers: customHeaders
    });
  }

  // Composable
  startApplication(data: any = {}): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/start-app", data, {
      headers: customHeaders,
    });
  }

  startAppWithIllustration(illustrationFile: File): Observable<any> {
    const customHeaders = new HttpHeaders().set(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    const formData: FormData = new FormData();
    formData.append('illustration', illustrationFile, illustrationFile.name);

    return this.http.post("/pdf/startAppWithIllustration", formData, {
      headers: customHeaders
    });

  }

  // Composable
  startDemoApplication(data: any = {}): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/start-demo-app", data, {
      headers: customHeaders,
    });
  }

  // Composable
  submitPayload(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/submit-payload", data, {
      headers: customHeaders,
    });
  }

  // Composable
  getDecision(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/get-decision", data, {
      headers: customHeaders,
    });
  }

  // Composable
  confirmApplication(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/confirm-app", data, {
      headers: customHeaders,
    });
  }

  // Composable
  isDemoApplication(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/is-demo-application", data, {
      headers: customHeaders,
    });
  }

    // Composable gets agent email (demo cases)
    getAgentEmail(data: any): Observable<any> {
      const customHeaders: any = new HttpHeaders().set(
        contentType,
        applicationJson
      );
      customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

      return this.http.post("/service/composable/get-agent-email", data, {
        headers: customHeaders,
      });
    }

  // Composable
  findApplication(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/find-application", data, {
      headers: customHeaders,
    });
  }
  // Internal Database
  dbResumeApplication(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/db-resume-application", {
      headers: customHeaders,
      AppAuthId: data.AppAuthId,
      AppId: data.AppId,
    });
  }
  // Composable
  resumeApplication(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/resume-application", {
      headers: customHeaders,
      AppAuthId: data.AppAuthId,
      AppId: data.AppId,
      CheckBlockStatus: data.CheckBlockStatus ?? true
    });
  }

  // Composable
  demoResumeApplication(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/demo-resume-application", {
      headers: customHeaders,
      AppId: data.AppId,
    });
  }

  // Composable
  getAgentApplications(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/get-agent-applications", {
      headers: customHeaders,
      AgentId: data,
      appDefName: "Brokerage E-App",
    });
  }

  // Composable
  processApplication(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/process-application", data, {
      headers: customHeaders,
    });
  }

  // Composable
  saveInfo(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/save-info", data, {
      headers: customHeaders,
    });
  }

  // LN Instant ID
  verifyIdentity(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/identity-check", data, {
      headers: customHeaders,
    });
  }

  // Policy Number
  generatePolicyNumber(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders({
      contentType: applicationJson,
      csrfToken: window["jhConfig"] ? window["jhConfig"].token : '',
    });

    return this.http.post('/ayco/generate-policy-number', data, {
      headers: customHeaders
    });
  }

  async getApplicationPdf(applicationId: string, mergeType: string) {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');
    const params: any = new HttpParams().set("appId", applicationId).set("mergeType", mergeType);
    //var i = "https://mockpdf1.free.beeceptor.com/appId";

    //return await this.http.get(i , { headers: _headers }).toPromise();

    return await this.http.get("/pdf/getApplicationPdf", {
      headers: customHeaders,
      params: params,
    }).toPromise();
  }


  sendJHEmail(data: any = {}): Observable<any> {
    const customHeaders: any = new HttpHeaders({
      contentType: applicationJson,
      csrfToken: window["jhConfig"] ? window["jhConfig"].token : '',
    });

    return this.http.post("/jhemail/sendJHEmail", data, {
      headers: customHeaders,
    });
  }

  resendEmail(data: any = {}): Observable<any> {
    const customHeaders: any = new HttpHeaders({
      contentType: applicationJson,
      csrfToken: window["jhConfig"] ? window["jhConfig"].token : '',
    });

    return this.http.post("/jhemail/resendEmail", data, {
      headers: customHeaders,
    });
  }

  sendDemoJHEmail(data: any = {}): Observable<any> {
    const customHeaders: any = new HttpHeaders({
      contentType: applicationJson,
      csrfToken: window["jhConfig"] ? window["jhConfig"].token : '',
    });

    return this.http.post("/jhemail/sendDemoJHEmail", data, {
      headers: customHeaders,
    });
  }

  sendJHUnlockEmail(data: any = {}): Observable<any> {
    const customHeaders: any = new HttpHeaders({
      contentType: applicationJson,
      csrfToken: window["jhConfig"] ? window["jhConfig"].token : '',
    });

    return this.http.post("/jhemail/sendJHUnlockEmail", data, {
      headers: customHeaders,
    });
  }
  sendOwnerEmail(data: any = {}): Observable<any> {
    const customHeaders: any = new HttpHeaders({
      contentType: applicationJson,
      csrfToken: window["jhConfig"] ? window["jhConfig"].token : '',
    });

    return this.http.post("/jhemail/sendOwnerEmail", data, {
      headers: customHeaders,
    });
  }

  customerSignedApplication(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post('/service/composable/customer-signed-application', data,{
      headers: customHeaders
    });
  }

  generatePDF(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');
    const httpOptions = {
      headers: customHeaders,
      responseType: "blob" as "json",
    };
    return this.http.post("/pdf/generatePDF", data, httpOptions);
  }

  demoCustomerSignedApplication(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post(
      "/service/composable/demo-customer-signed-application",
      data,
      {
        headers: customHeaders,
      }
    );
  }

  customerSignedWithOwners(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post('/service/composable/customer-signed-with-owners', data,{
      headers: customHeaders
    });
  }

  ownersSignedApplication(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post('/service/composable/owners-signed-application', data,{
      headers: customHeaders
    });
  }
  getFileContents(url: any): Observable<any> {
    const customHeaders: any = new HttpHeaders();
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    const httpOptions = {
      headers: customHeaders,
      responseType: "blob" as "json",
    };
    return this.http.get(url, httpOptions);
  }

  getApplicationAgents(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(
      contentType,
      applicationJson
    );
    customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

    return this.http.post("/service/composable/get-application-agents", {
      headers: customHeaders,
      ApplicationId: data,
    });
  }

  checkPendingBlocks(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);

    return this.http.post('/service/composable/check-pending-jobs', {
      headers: customHeaders,
      ApplicationId: data
    });
  }

  // to get user's ip address
  public getIPAddress() {
    return this.http.get('https://api.ipify.org/?format=json');
  }

  // encode querystring
  private encodeQuery = (data: any) => {
    const ret = [];
    for (const d in data) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    }
    return ret.join('&');
  }

  // ACTION resubmit JHADE Request
  resubmitJHADEReqAction(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);

    return this.http.post('/actions/resend-jhade-request', {
      headers: customHeaders,
      id: data['id']
    });
  }


  // ACTION generate policy number
  generatePolicyNumberAction(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);

    return data['productName'] ?
      this.http.post('/actions/generate-policy-number', {
        headers: customHeaders,
        appID: data['appID'],
        productName: data['productName']
      })
      :
      this.http.post('/actions/generate-policy-number', {
        headers: customHeaders,
        appID: data['appID']
      })
  }


  // ACTION Trigger Get Decisions
  triggerGetDecisionAction(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);

    return this.http.post('/actions/trigger-get-decision', {
      headers: customHeaders,
      appID: data['appID']
    });
  }


  // ACTION  Create Agent-Application relationship
  updateAppAgentRelationshipAction(data: any): Observable<any> {
    const customHeaders: any = new HttpHeaders().set(contentType, applicationJson);
    return this.http.post('/actions/update-app-agent-relationship', {
      headers: customHeaders,
      appID: data['appID'],
      agentID: data['agentID'],
      agentEmailAddress: data['agentEmailAddress'] ?? null,
      agentFirstName: data['agentFirstName'] ?? null,
      agentLastName: data['agentLastName'] ?? null
    });
  }

    // Composable
    getOwnerSignatories(data: any): Observable<any> {
      const customHeaders: any = new HttpHeaders().set(
        contentType,
        applicationJson
      );
      customHeaders.append(csrfToken, window["jhConfig"] ? window["jhConfig"].token : '');

      return this.http.post("/service/composable/get-owner-signatories", {
        headers: customHeaders,
        AppAuthId: data.AppAuthId,
        AppId: data.AppId,
      });
    }
}
